import { spacing } from "@minuthq/meatball-ui-react"

export const areaPaddingSize = spacing.L
